import type { FormFields } from '@atlaskit/feedback-collector';
import { EntryKeys } from '../../constants';

export const createAnalyticsPayload = (
	feedbackCollectorId?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	feedbackDetails: Partial<FormFields>,
) => ({
	additionalFeedbackEntries: [
		{
			key: EntryKeys.FEEDBACK_COLLECTOR_ID,
			value: feedbackCollectorId ?? 'empty',
		},
		{
			key: EntryKeys.IS_ATLASKIT_FEEDBACK_COMPONENT,
			value: 'true',
		},
		...(feedbackDetails.type
			? [
					{
						key: EntryKeys.REASON,
						value: feedbackDetails.type,
					},
				]
			: []),
	],
});
